/** @module Apparel/MaterialCopyBreadcrumbController */
define([
	"dojo/_base/declare",
	"csi/breadcrumb/CopyController",
	"csi/state"
], function(declare,CopyController,state) {

	return declare(CopyController, {
		constructor: function(params) {
			if (state.get("userType") == "Supplier") {
				params.m_action.m_viewRef.m_id = "NewSupplierMaterialForm";
			}
			this.inherited(arguments);
		},

		/**
		 * Overriding the method not to add the parent field.
		 * @param {Widget} view
		 */
		onCreatePopup: function(view) {
			//Parent (Material Security Group) is already part of Material Form
			//so, do nothing
		},

		/**
		* @override
		* Disables Save & Copy Button
		*/
		_canRepeat: function() {
			return false;
		}
	});
});